import {
  AGENT_NAME,
  COMPANY_ADDRESS_FULL,
  COMPANY_LOCATION,
  COMPANY_REGION,
  MAP_URL,
} from '../constants';

function VisitSection() {
  return (
    <section id="address" className="relative overflow-hidden bg-ink text-paper">
      <div className="relative mx-auto grid max-w-6xl gap-10 px-6 py-20 lg:grid-cols-[1.1fr_0.9fr] lg:items-center">
        <div>
          <p className="text-xs font-black uppercase text-cyan">
            Address
          </p>
          <h2 className="mt-3 text-4xl font-black tracking-tight text-paper sm:text-5xl">
            {COMPANY_LOCATION}
          </h2>
          <p className="mt-5 max-w-xl leading-8 text-paper/70">
            The filing lists the same location as the initial principal office,
            mailing address, and agent address for {COMPANY_REGION} public
            records.
          </p>
        </div>

        <div className="border border-white/12 bg-white/8 p-8 backdrop-blur">
          <p className="text-[11px] font-black uppercase text-cyan">
            Principal and mailing address
          </p>
          <p className="mt-3 text-3xl font-black leading-snug text-paper sm:text-4xl">
            {COMPANY_ADDRESS_FULL}
          </p>
          <div className="mt-7 border-t border-white/10 pt-5">
            <p className="text-[11px] font-black uppercase text-cyan">
              Agent for service of process
            </p>
            <p className="mt-2 text-xl font-semibold">{AGENT_NAME}</p>
          </div>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href={MAP_URL}
              target="_blank"
              rel="noreferrer"
              className="rounded-pill bg-cyan px-6 py-3 font-semibold text-ink transition hover:bg-amber"
            >
              Open in Google Maps
            </a>
            <a
              href="#top"
              className="rounded-pill border border-paper/25 px-6 py-3 font-semibold text-paper transition hover:bg-paper/10"
            >
              Back to top
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default VisitSection;
